const YOUTUBE_HOST_PATTERN = /(?:youtube\.com|youtu\.be|youtube-nocookie\.com)/i;

export const isYouTubeUrl = (url: string): boolean => YOUTUBE_HOST_PATTERN.test(url);

export const getYoutubeId = (url: string): string | null => {
  if (!url) return null;

  const shortMatch = url.match(/youtu\.be\/([^?&#/]+)/);
  if (shortMatch?.[1]) return shortMatch[1];

  const watchMatch = url.match(/[?&]v=([^?&#/]+)/);
  if (watchMatch?.[1]) return watchMatch[1];

  const embedMatch = url.match(/\/embed\/([^?&#/]+)/);
  if (embedMatch?.[1]) return embedMatch[1];

  return null;
};

export const getYoutubeEmbedUrl = (url: string): string => {
  const id = getYoutubeId(url);
  if (!id) return url;

  const embedUrl = `https://www.youtube-nocookie.com/embed/${id}`;
  const queryIndex = url.indexOf('?');
  const hashIndex = url.indexOf('#');

  if (queryIndex === -1 && hashIndex === -1) {
    return `${embedUrl}?rel=0`;
  }

  const params = new URLSearchParams();

  if (queryIndex !== -1) {
    const queryEnd = hashIndex !== -1 && hashIndex > queryIndex ? hashIndex : url.length;
    new URLSearchParams(url.slice(queryIndex + 1, queryEnd)).forEach((value, key) => {
      if (key !== 'v') params.set(key, value);
    });
  }

  if (hashIndex !== -1 && url.slice(hashIndex).startsWith('#t=')) {
    params.set('t', url.slice(hashIndex + 3).split('&')[0]);
  }

  params.set('rel', '0');
  return `${embedUrl}?${params}`;
};

/**
 * Convert embed/short/watch URLs to a standard YouTube watch URL for scanning/sharing.
 * Non-YouTube URLs (e.g. MP4) are returned unchanged.
 *
 * TODO(nh-video-deeplink): Prefer a Novaheal deep link (e.g. /app/video/:id) that opens
 * VideoBox/VideoModal after auth, once NH video blocks store videoId. Until then, QR codes
 * in the Video table should encode this watch URL (regenerate via backend script --force).
 */
export const getYoutubeWatchUrl = (url: string): string => {
  if (!isYouTubeUrl(url)) return url;

  const id = getYoutubeId(url);
  if (!id) return url;
  return `https://www.youtube.com/watch?v=${id}`;
};
